import { useMutation } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { baseUrl } from '@/data/subsidy/base';
import type { RefundableRequestByResource } from '@/data/subsidy/interfaces';

export const useCheckResourceEligibility = () => {
  return useMutation({
    mutationFn: async (
      resourceApprovalRequest: RefundableRequestByResource
    ) => {
      await falconClient.post(
        `${baseUrl}/policies/check_resource_eligibility`,
        resourceApprovalRequest
      );
    },
  });
};
